import * as sgvizler2 from '../index';
/**
 * Todo comment
 * @class sgvizler.Tools
 * @memberof sgvizler
 */
export class Tools {
    // noinspection JSValidateJSDoc
    /**
     * Gets the object located at `path` from `object`. `path`
     * is given in dot notation.
     * Search in first in the library and after in window object
     * @param {string} path
     * @param object
     * @returns { any }  or undefined
     */
    static getObjectByPath(path, object) {
        let i;
        let len;
        let segments = path.split('.');
        let cursor = object || sgvizler2; // search in the lib if object is empty
        for (i = 0, len = segments.length; i < len; i += 1) {
            if (cursor === undefined) { // create new child element.
                break;
            }
            if (i < len - 1) {
                cursor = cursor[segments[i]]; // if cursor is undefined, it remains undefined.
            }
            else {
                try {
                    cursor = new cursor[segments[i]](); // create an instance
                }
                catch (e) {
                    // do nothing
                    // cursor[segments[i]]() is not a constructor]
                    cursor = undefined;
                }
            }
        }
        if (cursor === undefined && !object) { // window is the global scope.
            cursor = this.getObjectByPath(path, window);
        }
        return cursor;
    }
    static assignProperty(obj, path, value) {
        return Tools.assignJSON(obj, Tools.getJSONByPath(path, value));
    }
    // public static escapeHtml (str: string): string {
    //     let text = document.createTextNode(str)
    //     let div = document.createElement('div')
    //     div.appendChild(text)
    //     return div.innerHTML
    // }
    // public static decodeHtml (html: string): any {
    // //     let element = document.createElement('div')
    // //     element.innerHTML = html
    // //     return element.textContent
    // // }
    // // function decodeHTMLEntities(text) {
    // }
    static encodeHtml(str) {
        let buf = [];
        for (let i = str.length - 1; i >= 0; i--) {
            // let iC = str.charCodeAt(i)
            // if (iC < 65 || iC > 127 ) { //|| (iC>90 && iC<97)
            //     buf.unshift(['&#', iC, ';'].join(''))
            // } else {
            //     buf.unshift(str[i])
            // }
            switch (str[i]) {
                case '&':
                    buf.unshift('&amp;');
                    break;
                case '"':
                    buf.unshift('&quot;');
                    break;
                case "'":
                    buf.unshift('&apos;');
                    break;
                case '<':
                    buf.unshift('&lt;');
                    break;
                case '>':
                    buf.unshift('&gt;');
                    break;
                // case '':
                //     buf.unshift(['&#', str.charCodeAt(i), ';'].join(''))
                //     break;
                default:
                    buf.unshift(str[i]);
            }
        }
        return buf.join('');
    }
    static decodeHtml(str) {
        let text = str.replace(/&#(\d+);/g, function (match, dec) {
            return String.fromCharCode(dec);
        });
        // remove \u00a0 of &nbsp;
        text = text.replace(/(?:[^\S\r\n]|\u00a0)/g, function (match, dec) {
            return ' ';
        });
        return text;
    }
    static getJSONByPath(path, value) {
        let json = '';
        let propertyName = '';
        let nextPath = '';
        if (path.length === 0 || !value) {
            return json;
        }
        let positionDot = path.search(/\./);
        if (positionDot === -1) {
            propertyName = path.trim();
            if (Number.isNaN(Number(value))) {
                let valueBoolean = Tools.convertToBoolean(value);
                if (valueBoolean === undefined) {
                    let str = JSON.stringify(String(value));
                    str = str.substring(1, str.length - 1);
                    json = '{"' + propertyName + '":"' + str + '"}';
                }
                else {
                    json = '{"' + propertyName + '":' + value + '}';
                }
            }
            else {
                json = '{"' + propertyName + '":' + value + '}';
            }
        }
        else {
            propertyName = path.substring(0, positionDot);
            nextPath = path.substring(positionDot + 1, path.length);
            json = '{"' + propertyName.trim() + '": ' + Tools.getJSONByPath(nextPath, value) + ' }';
        }
        return json;
    }
    static assignJSON(obj, json) {
        Tools.mergeInObject(obj, JSON.parse(json));
        return obj;
    }
    static convertToBoolean(input) {
        if (input.length <= 5) {
            try {
                return JSON.parse(input);
            }
            catch (e) {
                return undefined;
            }
        }
        return undefined;
    }
    // Convert to typescript : https://github.com/gmasmejean/recursiveAssign/blob/master/index.js
    static assign(ref, key, value) {
        if (Tools.isPlainObject(value)) {
            if (!Tools.isPlainObject(ref[key])) {
                ref[key] = {};
            }
            Tools.mergeInObject(ref[key], value);
        }
        else {
            ref[key] = value;
        }
    }
    static mergeInObject(dest, data) {
        Object.keys(data).forEach(key => {
            Tools.assign(dest, key, data[key]);
        });
    }
    static isPlainObject(o) {
        return o !== undefined && o.constructor !== undefined && o.constructor.prototype === Object.prototype;
    }
    static sizeConvertInteger(x) {
        var val = x;
        // Fix bug: TypeError: x.replace is not a function
        if (typeof x !== 'number') {
            val = parseInt(x.replace("px", ""), 10);
        }
        if (isNaN(val)) {
            return null;
        }
        return val;
    }
}
//# sourceMappingURL=data:application/json;base64,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